// 生成一个16进制的随机数
const randomNumber = () => Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);;

/**
 * @description: 生成UUID
 * @param {*} len
 * @return {*} String UUID
 */
export const uuid = (len = -1) => {
    // 如果没有指定长度，就按照标准的UUID格式返回
    if (len === -1) return `${randomNumber()}${randomNumber()}-${randomNumber()}-${randomNumber()}-${randomNumber()}-${randomNumber()}${randomNumber()}${randomNumber()}`;
    // 否则就返回指定长度的随机字符串
    return randomNumber().repeat(Math.ceil(len / 4)).substring(0, len);
}